import {
  Avatar,
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import FormatService from "../../services/formatService";

export interface ItemListElement {
  id: string | number;
  path?: string;
  name: string;
  value: number;
  img?: string;
  logo?: string;
  profile_image?: string;
  picture?: string;
}

interface SortedItemsListProps {
  title: string;
  list: Array<ItemListElement>;
  fullListUrl?: string;
  renderName?: Function;
  renderValue?: Function;
  defaultAvatarImg: string;
  onClick?: Function;
  maxItems?: number;
}

const SortedItemsList = ({
  title,
  list,
  fullListUrl,
  renderName,
  renderValue,
  defaultAvatarImg,
  onClick,
  maxItems,
}: SortedItemsListProps) => {
  const { getUrlLogo } = FormatService();

  const itemClick = (id: string | number) => {
    if (onClick) {
      onClick(id);
    }
  };

  const returnLogo = (item: ItemListElement) => {
    let data =
      item.logo || item.picture ? (
        <Box width={30}>
          <img
            className="banner"
            src={getUrlLogo(
              item.logo ? item.logo : item.picture ? item.picture : ""
            )}
            alt={"banner image"}
          />
        </Box>
      ) : (
        <Avatar
          alt={`${item.name}`}
          src={
            item.img
              ? item.img
              : item.profile_image
                ? item.profile_image
                : defaultAvatarImg
          }
        />
      );
    return data;
  };

  return (
    <Box
      aria-label="Most Popular players Container"
      height={"100%"}
      marginBottom={"10px"}
    >
      <Box width={"100%"} aria-label="Most Popular player Inside Container">
        <Typography
          variant="whyTitle"
          sx={{
            fontSize: "1.2rem !important",
            color: "#6f7d95 !important",
            textAlign: "left",
            marginBottom: "1rem",
          }}
        >
          {title}
        </Typography>
        <Box sx={{ width: "100%" }}>
          {list.map((item, key) => {
            if (maxItems && key < maxItems) {
              const labelId = `checkbox-list-secondary-label-${item.id}`;
              return (
                <Box
                  key={item.id}
                  sx={{
                    marginBottom: "10px",
                    padding: "10px 16px",
                    borderRadius: "10px",
                    backgroundColor: "white !important",
                    minHeight: "50px",
                  }}
                >
                  <ListItem key={item.id} disablePadding sx={{ width: "100%" }}>
                    <ListItemButton
                      onClick={() => itemClick(item.id)}
                      sx={{ borderRadius: "7px" }}
                    >
                      <ListItemAvatar>{returnLogo(item)}</ListItemAvatar>
                      <ListItemText
                        id={labelId}
                        primary={
                          <Typography variant="followCardUserName">
                            {renderName ? renderName(item.name) : item.name}
                          </Typography>
                        }
                        secondary={
                          <Typography
                            variant="body1"
                            sx={{ color: "#4663ff !important" }}
                          >
                            {renderValue ? renderValue(item.value) : item.value}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </Box>
              );
            } else {
              return null;
            }
          })}
        </Box>
      </Box>

      {fullListUrl && (
        <Box display="flex" justifyContent="flex-end" sx={{ width: "100%" }}>
          <Box>
            <Link to={fullListUrl}>
              <Button variant="customBlueTextUnderLine">
                {"See full list"}
              </Button>
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SortedItemsList;
